import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'formly-repeat-section',
  styleUrls: ['repeat-section.component.css'],
  template: `
    <strong>{{to?.label}}</strong><hr />
    <div *ngFor="let fl of field.fieldGroup; let i = index;" class="repeat-section">
      <strong>{{to?.innerLabel}} {{i+1}}</strong><hr>
      <formly-field [field]="fl"></formly-field>
      <div *ngIf="!formState?.disabled">
        <button 
          class="btn btn-danger mb-1" 
          *ngIf="field?.fieldGroup?.length > 1 && formState.status =='RG'" 
          type="button" 
          (click)="remove(i)"
        >
          {{ 'GENERIC.REMOVE' | translate }}
        </button>
      </div>
    </div>
    <button 
      class="btn btn-primary mb-1 float-right" 
      type="button" 
      [disabled]="model?.length>=to?.length" 
      *ngIf="formState.status =='RG' && !formState?.disabled" 
      (click)="add(field.fieldGroup.length,{ markAsDirty: true });"
    >
      {{ to?.addButton }}
    </button>
  `,
})
export class RepeatTypeComponent extends FieldArrayType {
  
}

